import script from "./EventSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSelect.vue?vue&type=script&setup=true&lang=js"

import "./EventSelect.vue?vue&type=style&index=0&id=163bb14c&scoped=true&lang=css"
import "./EventSelect.vue?vue&type=style&index=1&id=163bb14c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163bb14c"]])

export default __exports__